import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';
import { ErrorIcon, RunIcon, SuccessIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { AiProcessExecutionStatus } from 'constants/aiProcessRuns';
import { IconSize } from 'constants/coreDesignSystem';

import { StatusIconAppearance } from '../../RunRow.constants';
import { getCompactStatusIconStyles, getStatusIconStyles } from '../../RunRow.styles';

const DEFAULT_STATUS_ICON = RunIcon;

const STATUS_TO_ICON = {
  [AiProcessExecutionStatus.COMPLETED]: SuccessIcon,
  [AiProcessExecutionStatus.FAILED]: ErrorIcon,
};

const StatusIcon = ({ status, compact = false }) => {
  const appearance = useMemo(
    () => StatusIconAppearance[status] ?? StatusIconAppearance[AiProcessExecutionStatus.PENDING],
    [status],
  );

  const sx = useMemo(
    () => (compact ? getCompactStatusIconStyles(appearance) : getStatusIconStyles(appearance)),
    [compact, appearance],
  );

  const Icon = STATUS_TO_ICON[status] ?? DEFAULT_STATUS_ICON;

  return (
    <Box sx={sx}>
      <Icon size={compact ? IconSize[12] : IconSize[16]} />
    </Box>
  );
};

StatusIcon.propTypes = {
  status: PropTypes.string,
  compact: PropTypes.bool,
};

export default memo(StatusIcon);
